import React, { Component } from "react"
import Modal from "react-modal"
import CustomerInvoicesUpdateModalUI from "./CustomerInvoicesUpdateModalUI"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"
import { withRouter } from 'react-router-dom'

class CustomerInvoicesUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,

      submitted: false,

      invoiceName: '',
      invoiceNameError: null,
      dueDate: '',
      dueDateError: null,
      customerNotes: '',
      customerNotesError: null,
      customerId: '',
      customerIdError: null,
      //
      invoiceNumber: '',
      invoiceNumberError: null,
      eWayBill: '',
      eWayBillError: null,
      vehicleNumber: '',
      vehicleNumberError: null,
      dateOfSupply: '',
      dateOfSupplyError: null,
      orderDate: '',
      orderDateError: null,
      orderNumber: '',
      orderNumberError: null,
      productDescription: '',
      productDescriptionError: null,
      customerName: null,
    }
  }

  render() {
    return (
      <CustomerInvoicesUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}

        updateMode={this.props.updateMode}
        submitted={this.state.submitted}

        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}

        invoiceName={this.state.invoiceName}
        onInvoiceNameChange={(event) => { this.setState({ invoiceName: event.target.value }) }}
        invoiceNameError={this.state.invoiceNameError}
        setInvoiceNameError={(error) => { this.setState({ invoiceNameError: error }) }}

        // dueDate={this.state.dueDate}
        // onDueDateChange={(selectedDateISO) => {
        //     this.setState({dueDate: selectedDateISO})
        //   }}
        // dueDateError={this.state.dueDateError}
        // setDueDateError={(error) => { this.setState({ dueDateError: error }) }}

        customerNotes={this.state.customerNotes}
        onCustomerNotesChange={(event) => { this.setState({ customerNotes: event.target.value }) }}
        customerNotesError={this.state.customerNotesError}
        setCustomerNotesError={(error) => { this.setState({ customerNotesError: error }) }}

        customerName={this.state.customerName}
        // onCustomerIdChange={(event) => { this.setState({ customerId: event.target.value }) }}
        // customerIdError={this.state.customerIdError}
        // setCustomerIdError={(error) => { this.setState({ customerIdError: error }) }}
        // customerList={this.props.customerList}
        //
        invoiceNumber={this.state.invoiceNumber}
        onInvoiceNumberChange={(event) => { this.setState({ invoiceNumber: event.target.value }) }}
        invoiceNumberError={this.state.invoiceNumberError}
        setInvoiceNumberError={(error) => { this.setState({ invoiceNumberError: error }) }}
        //
        eWayBill={this.state.eWayBill}
        onEWayBillChange={(event) => { this.setState({ eWayBill: event.target.value }) }}
        eWayBillError={this.state.eWayBillError}
        setEWayBillError={(error) => { this.setState({ eWayBillError: error }) }}
        //
        vehicleNumber={this.state.vehicleNumber}
        onVehicleNumberChange={(event) => { this.setState({ vehicleNumber: event.target.value }) }}
        vehicleNumberError={this.state.vehicleNumberError}
        setVehicleNumberError={(error) => { this.setState({ vehicleNumberError: error }) }}
        //
        dateOfSupply={this.state.dateOfSupply}
        onDateOfSupplyChange={(selectedDateISO) => { this.setState({ dateOfSupply: selectedDateISO }) }}
        dateOfSupplyError={this.state.dateOfSupplyError}
        setDateOfSupplyError={(error) => { this.setState({ dateOfSupplyError: error }) }}
        //
        orderDate={this.state.orderDate}
        onOrderDateChange={(selectedDateISO) => { this.setState({ orderDate: selectedDateISO }) }}
        orderDateError={this.state.orderDateError}
        setOrderDateError={(error) => { this.setState({ orderDateError: error }) }}
        //
        orderNumber={this.state.orderNumber}
        onOrderNumberChange={(event) => { this.setState({ orderNumber: event.target.value }) }}
        orderNumberError={this.state.orderNumberError}
        setOrderNumberError={(error) => { this.setState({ orderNumberError: error }) }}
        //
        productDescription={this.state.productDescription}
        onProductDescriptionChange={(event) => { this.setState({ productDescription: event.target.value }) }}
        productDescriptionError={this.state.productDescriptionError}
        setProductDescriptionError={(error) => { this.setState({ productDescriptionError: error }) }}
      />
    )
  }

  onCancelClick = () => {
    this.setState({
      submitted: false,
      errorList: null
    })
    this.props.onCancelClick()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    const { selectedInvoice } = this.props;
    if (selectedInvoice && (!prevProps.selectedInvoice || prevProps.selectedInvoice.customerInvoiceId !== selectedInvoice.customerInvoiceId)) {
      this.setState({
        invoiceName: selectedInvoice.invoiceName,
        customerName: selectedInvoice.customerName,
        dueDate: selectedInvoice.dueDate,
        customerNotes: selectedInvoice.customerNotes,
        customerId: selectedInvoice.customerId,
        invoiceNumber: selectedInvoice.invoiceNumber,
        eWayBill: selectedInvoice.eWayBill,
        vehicleNumber: selectedInvoice.vehicleNumber,
        dateOfSupply: selectedInvoice.dateOfSupply,
        orderDate: selectedInvoice.orderDate,
        orderNumber: selectedInvoice.orderNumber,
        productDescription: selectedInvoice.productDescription,
      });
    }
  }


  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/customerInvoices/${this.props.selectedInvoice.customerInvoiceId}`,
      this.onSubmitCallback, {
      invoiceName: this.state.invoiceName,
      dueDate: this.state.dueDate,
      customerNotes: this.state.customerNotes,
      customerId: this.state.customerId,
      invoiceNumber: this.state.invoiceNumber,
      eWayBill: this.state.eWayBill,
      vehicleNumber: this.state.vehicleNumber,
      dateOfSupply: this.state.dateOfSupply,
      orderDate: this.state.orderDate,
      orderNumber: this.state.orderNumber,
      productDescription: this.state.productDescription,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(CustomerInvoicesUpdateModalSF);